<mat-checkbox
    #nativeElement

    (change)="changeValue($event)"

    [color]="asFormsControl().color"
    [checked]="asFormsControl().getChecked()"
    [disabled]="asFormsControl().disabled || disabled"

    class="d-block"
>
    <ng-content select="[text]"></ng-content>
</mat-checkbox>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
